import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import ScrollToTop from '@/components/base/ScrollToTop';
import { articles } from '@/mocks/articles';

const articleDetailImages: Record<string, string> = {
  'article-chengrengaokao': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20education%20learning%20concept%20with%20minimalist%20books%20and%20warm%20lighting%2C%20soft%20gradient%20background%20in%20cream%20and%20warm%20beige%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=1200&height=500&seq=detail-chengrengaokao&orientation=landscape',
  'article-zixuekaoshi': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20self%20study%20education%20concept%20with%20neat%20desk%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=1200&height=500&seq=detail-zixuekaoshi&orientation=landscape',
  'article-wangluojiaoyu': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20online%20learning%20concept%20with%20laptop%20and%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=1200&height=500&seq=detail-wangluojiaoyu&orientation=landscape',
  'article-guokaida': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20university%20education%20concept%20with%20minimalist%20composition%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=1200&height=500&seq=detail-guokaida&orientation=landscape',
  'article-beikao': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20exam%20preparation%20concept%20with%20notebooks%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=1200&height=500&seq=detail-beikao&orientation=landscape',
  'article-lunwen': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20thesis%20writing%20concept%20with%20papers%20and%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=1200&height=500&seq=detail-lunwen&orientation=landscape',
  'article-xiaolv': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20productivity%20learning%20concept%20with%20minimalist%20desk%20setup%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=1200&height=500&seq=detail-xiaolv&orientation=landscape',
  'article-zhichang': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20career%20development%20concept%20with%20minimalist%20office%20elements%20and%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=1200&height=500&seq=detail-zhichang&orientation=landscape',
  'article-zhengce': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20education%20policy%20concept%20with%20documents%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=1200&height=500&seq=detail-zhengce&orientation=landscape',
  'article-tiyan': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20student%20experience%20education%20concept%20with%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=1200&height=500&seq=detail-tiyan&orientation=landscape',
  'article-shuxue': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20mathematics%20learning%20concept%20with%20formulas%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=1200&height=500&seq=detail-shuxue&orientation=landscape',
  'article-yingyu': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20English%20language%20learning%20concept%20with%20books%20and%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=1200&height=500&seq=detail-yingyu&orientation=landscape',
};

const relatedThumbnails: Record<string, string> = {
  'article-chengrengaokao': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20education%20learning%20concept%20with%20minimalist%20books%20and%20warm%20lighting%2C%20soft%20gradient%20background%20in%20cream%20and%20warm%20beige%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-chengrengaokao&orientation=landscape',
  'article-zixuekaoshi': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20self%20study%20education%20concept%20with%20neat%20desk%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-zixuekaoshi&orientation=landscape',
  'article-wangluojiaoyu': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20online%20learning%20concept%20with%20laptop%20and%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-wangluojiaoyu&orientation=landscape',
  'article-guokaida': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20university%20education%20concept%20with%20minimalist%20composition%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-guokaida&orientation=landscape',
  'article-beikao': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20exam%20preparation%20concept%20with%20notebooks%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-beikao&orientation=landscape',
  'article-lunwen': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20thesis%20writing%20concept%20with%20papers%20and%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-lunwen&orientation=landscape',
  'article-xiaolv': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20productivity%20learning%20concept%20with%20minimalist%20desk%20setup%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-xiaolv&orientation=landscape',
  'article-zhichang': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20career%20development%20concept%20with%20minimalist%20office%20elements%20and%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-zhichang&orientation=landscape',
  'article-zhengce': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20education%20policy%20concept%20with%20documents%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-zhengce&orientation=landscape',
  'article-tiyan': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20student%20experience%20education%20concept%20with%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-tiyan&orientation=landscape',
  'article-shuxue': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20mathematics%20learning%20concept%20with%20formulas%20and%20warm%20lighting%2C%20soft%20cream%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-shuxue&orientation=landscape',
  'article-yingyu': 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20English%20language%20learning%20concept%20with%20books%20and%20warm%20lighting%2C%20soft%20beige%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20no%20people%20no%20text&width=640&height=400&seq=article-yingyu&orientation=landscape',
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const article = articles.find((a) => a.id === id);

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="pt-20 text-center py-20">
          <h1 className="font-heading text-2xl text-foreground-900">文章未找到</h1>
          <Link to="/" className="text-primary-600 mt-4 inline-block cursor-pointer">返回首页</Link>
        </div>
        <Footer />
      </div>
    );
  }

  const relatedArticles = articles
    .filter((a) => a.category === article.category && a.id !== article.id)
    .slice(0, 3);

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={`${article.title} - 成人高清学历提升平台`}
        description={article.summary}
        keywords={article.tags.join(',')}
        canonicalUrl={`https://www.chengrengaoqing.com/article/${article.id}`}
        ogTitle={article.title}
        ogDescription={article.summary}
        ogImage={articleDetailImages[article.imageSeq]}
        ogType="article"
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.chengrengaoqing.com/' },
            { '@type': 'ListItem', position: 2, name: article.categoryName, item: `https://www.chengrengaoqing.com/category/${article.category}` },
            { '@type': 'ListItem', position: 3, name: article.title },
          ],
        }}
      />
      <SchemaOrg
        type="Article"
        data={{
          headline: article.title,
          description: article.summary,
          datePublished: article.publishDate,
          author: { '@type': 'Person', name: article.author },
          url: `https://www.chengrengaoqing.com/article/${article.id}`,
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: article.categoryName, path: `/category/${article.category}` },
              { label: article.title },
            ]}
          />

          <article className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-3xl mx-auto">
              <div className="mb-8">
                <div className="flex items-center gap-3 mb-4 flex-wrap">
                  <Link
                    to={`/category/${article.category}`}
                    className="px-3 py-1 rounded-full text-xs bg-secondary-100 text-secondary-700 hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {article.categoryName}
                  </Link>
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-400">{article.author}</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.readCount.toLocaleString()} 阅读
                  </span>
                </div>
                <h1 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4 leading-tight">
                  {article.title}
                </h1>
                <p className="text-foreground-600 leading-relaxed">{article.summary}</p>
              </div>

              <div className="rounded-xl overflow-hidden mb-10">
                <img
                  src={articleDetailImages[article.imageSeq]}
                  alt={article.title}
                  className="w-full object-cover"
                />
              </div>

              <div
                className="prose prose-sm md:prose-base max-w-none
                  prose-headings:font-heading prose-headings:text-foreground-900
                  prose-p:text-foreground-700 prose-p:leading-relaxed
                  prose-strong:text-foreground-900
                  prose-h2:text-xl prose-h2:mt-8 prose-h2:mb-4
                  prose-h3:text-lg prose-h3:mt-6 prose-h3:mb-3"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />

              <div className="flex flex-wrap gap-2 mt-10 pt-8 border-t border-background-200/70">
                {article.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 rounded-full text-xs bg-background-100 text-foreground-600 border border-background-200/70 whitespace-nowrap"
                  >
                    #{tag}
                  </span>
                ))}
              </div>

              {relatedArticles.length > 0 && (
                <div className="mt-12 pt-8 border-t border-background-200/70">
                  <h2 className="font-heading text-xl text-foreground-950 mb-5">相关文章</h2>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    {relatedArticles.map((ra) => (
                      <Link
                        key={ra.id}
                        to={`/article/${ra.id}`}
                        className="group rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer overflow-hidden"
                      >
                        <div className="aspect-[16/10] overflow-hidden">
                          <img
                            src={relatedThumbnails[ra.imageSeq]}
                            alt={ra.title}
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                            loading="lazy"
                          />
                        </div>
                        <div className="p-3">
                          <h3 className="font-heading text-sm text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                            {ra.title}
                          </h3>
                          <p className="text-xs text-foreground-400 mt-1">{ra.publishDate}</p>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
}